import { CategoryLists } from '@/models/CategoryKey';

export const ModelKey = {
	Canister02_01: 'Canister02_01_BookShelf',
	Canister02_02: 'Canister02_02_DeskShelf',
	Canister02_03: 'Canister02_03_ShoeRackB',
	Canister02_04: 'Canister02_04_DeskStationeryB',
	Canister02_05: 'Canister02_05_DeskStationeryC',
	Canister02_06: 'Canister02_06_CoinBankA',
};

export default {
	categoryKey: CategoryLists.Vacuum.list.Canister02,
	cover: {
		caption: 'LandingPage.Canister02',
		backgroundImage: require('../../cover_image/cover_bookshelf.png'),
		mobileCoverImage: require('../../cover_image/cover_bookshelf.png'),
		mainImage: {
			src: require('../../../assets/categories/Canister02.png'),
			pcSrc: require('../../../assets/categories/Canister02.png'),
		},
	},
	box: {
		title: 'ProductPage.selectDesign', //i18n
		list: [
			{
				key: ModelKey.Canister02_04,
				image: {
				  mobile: require('../../thumbnail/DeskStationaryB.png'),
				  pc: require('../../thumbnail/DeskStationaryB.png'),
				},
				title: 'ProductPage.DeskStationary', // i18n
				text: 'B',
				level: 3,
				minutes: 60,
				allowInches: ['VC4100','VC7100'],
			  },
			  {
				key: ModelKey.Canister02_05,
				image: {
				  mobile: require('../../thumbnail/DeskStationaryC.png'),
				  pc: require('../../thumbnail/DeskStationaryC.png'),
				},
				title: 'ProductPage.DeskStationary', // i18n
				text: 'C',
				level: 3,
				minutes: 60,
				allowInches: ['VC4100','VC7100'],
			  },
			  {
				key: ModelKey.Canister02_06,
				image: {
				  mobile: require('../../thumbnail/CoinBankA.png'),
				  pc: require('../../thumbnail/CoinBankA.png'),
				},
				title: 'ProductPage.CoinBank', // i18n
				text: 'A',
				level: 2,
				minutes: 60,
				allowInches: ['VC4100','VC7100'],
			  },
			{
				key: ModelKey.Canister02_01,
				image: {
					mobile: require('../../thumbnail/Book_shelf.png'),
					pc: require('../../thumbnail/Book_shelf.png'),
				},
				title: 'ProductPage.BookShelf', // i18n
				level: 2,
				minutes: 60,
				allowInches: ['VC4100','VC7100'],
			},
			{
				key: ModelKey.Canister02_03,
				image: {
					mobile: require('../../thumbnail/shoerackB.png'),
					pc: require('../../thumbnail/shoerackB.png'),
				},
				title: 'ProductPage.ShoeRackB', // i18n
				level: 2,
				minutes: 80,
				allowInches: ['VC4100','VC7100'],
			},
			{
				key: ModelKey.Canister02_02,
				image: {
					mobile: require('../../thumbnail/Desk_shelf.png'),
					pc: require('../../thumbnail/Desk_shelf.png'),
				},
				title: 'ProductPage.DeskShelf', // i18n
				level: 3,
				minutes: 80,
				allowInches: ['VC4100','VC7100'],
			},
		],
	},
	dezeenBox: {},
	worldcup:{},
	disney:{},
	ModelKey: ModelKey,
};

export const Boxes = {
	[ModelKey.Canister02_01]: () => import('./bookshelf'),
	[ModelKey.Canister02_02]: () => import('./deskshelf'),
	[ModelKey.Canister02_03]: () => import('./shoerackB'),
	[ModelKey.Canister02_04]: () => import('./deskstationeryB'),
	[ModelKey.Canister02_05]: () => import('./deskstationeryC'),
	[ModelKey.Canister02_06]: () => import('./coinbankA'),
};
